const fieldsErrors = {
  required: 'Required',
  max: (value) => `Max: ${value}`,
  min: (value) => `Min: ${value}`,
  withoutAt: '"@" symbol already is',
};

export default fieldsErrors;
